export const environment = {
    production: false,
    base: 'fpc.interspark.dev',
    baseUrl: 'https://auth.fpc.interspark.dev/api/v1',
    authUrl: 'https://auth.fpc.interspark.dev/api',
    applicationBaseUrl: 'https://auth.fpc.interspark.dev',
    applicationAuthUrl: 'https://auth.fpc.interspark.dev',
};
